import styled from "styled-components"
import { Typography } from "../typography"

const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
`

type Position = "top-left" | "top-right" | "bottom-left" | "bottom-right"

const TooltipContent = styled(Typography).attrs<{ $position: Position; $maxWidth: string }>(() => ({
  as: "div",
}))`
  /* hide tooltips by default */
  display: none;
  ${({ $position }) => ($position.endsWith("right") ? "left: 100%;" : "right: 100%;")}
  ${({ $position }) => ($position.startsWith("top") ? "bottom: calc(100% + 0.25rem);" : "top: calc(100% + 0.25rem);")}
  position: absolute;
  padding: 0.5em 1rem;
  background-color: ${({ theme }) => theme.colors.grey.$600};
  border-radius: 0.3125rem;
  max-width: ${({ $maxWidth }) => $maxWidth};
  width: max-content;
  color: ${({ theme }) => theme.colors.white};
  word-wrap: break-word;
  white-space: normal;
  z-index: 1;
`

const TooltipTrigger = styled.div`
  &:hover + [role="tooltip"],
  &:focus + [role="tooltip"] {
    display: block;
  }

  width: 100%;
  display: flex;
`

export const Tooltip = ({
  id,
  content,
  children,
  position = "bottom-right",
  maxWidth = "16rem",
  as,
}: {
  content: string
  children: JSX.Element | string
  id: string
  position?: Position
  maxWidth?: string
  as?: React.ElementType
}) => {
  if (!content) {
    return <>{children}</>
  }

  return (
    <TooltipWrapper as={as}>
      <TooltipTrigger aria-describedby={id}>{children}</TooltipTrigger>
      <TooltipContent id={id} role="tooltip" $position={position} $maxWidth={maxWidth}>
        {content}
      </TooltipContent>
    </TooltipWrapper>
  )
}
